import React from 'react'

import { plugins } from './storefront.plugins'
import { Hook, IPluginSettings, ICollectionProduct, IProductAddToCart, IProductDetail } from '@engyalo/storefront-types'

export const usePlugin = (hook: Hook): IPluginSettings => {
    return plugins[hook]
}
interface IPluginProps {
    hook: Hook
    pluginProps: ICollectionProduct | IProductAddToCart | IProductDetail
    children: JSX.Element
}

const Plugin: React.FC<IPluginProps> = ({ hook, pluginProps, children }: IPluginProps) => {
    const plugin = plugins[hook]

    if (plugin?.container) {
        const PluginContainer = plugin.container
        return <PluginContainer {...pluginProps} />
    }

    return <>{children}</>
}

export default Plugin
